export default "__VITE_ASSET__qmRyz$rK__"